import { render, staticRenderFns } from "./Dati.vue?vue&type=template&id=5ccd96d5&"
import script from "./Dati.vue?vue&type=script&lang=js&"
export * from "./Dati.vue?vue&type=script&lang=js&"
import style0 from "./Dati.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Dati.vue"
export default component.exports